<div class="ui-g-12" style="text-align: center; color: #013a71;">
  <div class="ui-g-12" >
    <h2 style="font-weight: 400; font-size: 30px; color: #073c8f; font-family: poppins; text-align: center; margin-top: 1%;">Detalle de confirmación</h2>
  </div>
  <div class="ui-g-12">
    <div class=" ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;" >Nombre:</label>
        </div>
        <div class="ui-g-12">
          <h3> Sergio Santisteban</h3>
        </div>
      </div>
    </div>
    <div class=" ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">Carne:</label>
        </div>
        <div class="ui-g-12">
          <h3>502-605020</h3>
        </div>
      </div>
    </div>
    <div class="p-field ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">Proveedor</label>
        </div>
        <div class="ui-g-12">
          <h3>Medico Prueba</h3>
        </div>
      </div>
    </div>
    <div class="p-field ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">Copago</label>
        </div>
        <div class="ui-g-12">
          <h3>Q 50.00</h3>
        </div>
      </div>
    </div>
    <div class="p-field ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">Nombre de la tarjeta</label>
        </div>
        <div class="ui-g-12">
          <h3>Sergio Santisteban V.</h3>
        </div>
      </div>
    </div>
    <div class="p-field ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">Numero de tarjeta</label>
        </div>
        <div class="ui-g-12">
          <h3>999-999-999-999</h3>
        </div>
      </div>
    </div>
    <div class="p-field ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">fecha</label>
        </div>
        <div class="ui-g-12">
          <h3>08/25</h3>
        </div>
      </div>
    </div>
    <div class="p-field ui-g-6 ui-sm-12">
      <div class="ui-g-10" style="border: 0.05px solid #073c8f; border-radius: 1em;">
        <div class="ui-g-12">
          <label style="color: #898A8F; font-weight: 400; font-family: poppins;">CVV</label>
        </div>
        <div class="ui-g-12">
          <h3>1234</h3>
        </div>
      </div>
    </div>
  </div>
  </div>
  
<div class="ui-g-12">
  <div class="p-grid p-nogutter p-justify-between">
    <p-button label="Regresar" (onClick)="prevPage()" icon="pi pi-angle-left"></p-button>
    <p-button label="Continuar" (onClick)="complete()" icon="pi pi-angle-right" iconPos="right" styleClass="p-button-success"></p-button>
  </div>
</div>

